import { useEffect, useState } from 'react';
import './leagues-list.styles.scss';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { listenToCollection } from '@/utils/getDataFromDb';
import { phaseLabel } from '@/utils/leagueLabels';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

const LeaguesList = () => {

    const [ leagues, setLeagues ] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        let listener;
        listenToCollection({
            'path': 'leagues',
            'callback': setLeagues,
            'handleListener': (unsub) => { listener = unsub; },
        });
        return () => {
            if (listener) listener();
        }
    }, [])

    // Old-format leagues (from before Phase 2) have no settings; hide them.
    const list = leagues && Object.values(leagues)
        .filter(l => l.settings)
        .sort((a, b) => (b.ts_created ?? 0) - (a.ts_created ?? 0));

    return (
        <div className='leagues-list'>
            <div className='section-title'>
                <span>Leagues</span>
                <button className='g-button primary' onClick={() => navigate('/admin/leagues/new')}>
                    <FontAwesomeIcon icon={faPlus} /> Create League
                </button>
            </div>
            {!list && <div className='center-col'><ThreeDotsLoader /></div>}
            {list && list.length === 0 &&
                <div className='g-card empty'>
                    <p>No leagues yet. Create one to generate teams, rosters and a schedule.</p>
                </div>
            }
            <div className='league-cards'>
                {list && list.map(l => (
                    <button key={l.id} className='g-card league-card' onClick={() => navigate(`/admin/leagues/${l.id}`)}>
                        <div className='league-card-main'>
                            <div className='league-name'>{l.name}</div>
                            <div className='meta'>
                                {l.settings.type === 'pro' ? 'Pro' : 'College'} · {l.settings.teamCount} teams · {Object.keys(l.conferences ?? {}).length} conferences
                            </div>
                            <div className='league-phase'>{phaseLabel(l.season, l.type)}</div>
                        </div>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                ))}
            </div>
        </div>
    )
}

export default LeaguesList
